import { computed, inject, Injectable } from '@angular/core';
import { KommissionierungAddOnParams } from '@softapps/lager/kommissionierung/api';
import { AddOn, menuItems } from '@softline/application';
import { authorizationFn } from '@softline/auth';
import { Store } from '@softline/core';
import {
  MessageBarStore,
  ModalStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  SOFTLINE_FEATURE_MODAL,
} from '@softline/ui-core';
import { MengenAuswahlDialog } from '../dialogs/mengen-auswahl/mengen-auswahl.dialog';
import { UmbuchungsartikelAuswahlDialog } from '../dialogs/umbuchungsartikel-auswahl/umbuchungsartikel-auswahl.dialog';
import {
  SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL,
  SOFTLINE_PERMISSION_LAGERKORREKTUR_ARTIKEL,
} from '../lagerkorrektur-artikel.shared';
import { LagerkorrekturArtikelStore } from '../store';

@Injectable()
export class LagerkorrekturKommissionierungAddon extends AddOn<KommissionierungAddOnParams> {
  private store = inject(Store);
  private isAuthorized = authorizationFn();
  /*computed(() => {
    const hostParams = this.hostParams();
    if(!hostParams)
      return false;
    return !!hostParams.auftrag().pipe(map((o: any) => o.lagerplatzAuswahl))
  }),*/
  private hasLagerplatzAuswahl = computed(
    () => !!this.hostParams()?.auftrag()?.lagerplatzAuswahl
  );

  constructor() {
    super();
    menuItems(() => {
      if (!this.isAuthorized(SOFTLINE_PERMISSION_LAGERKORREKTUR_ARTIKEL)) return [];
      return [
        {
          type: 'execute',
          name: '',
          title: '#LAGERKORREKTUR_ARTIKEL.TITLE',
          icon: 'fa-regular fa-circle-minus',
          outlet: 'action',
          canExecute: computed(() => this.hasLagerplatzAuswahl()),
          execute: async () => {
            const hostParams = this.hostParams();
            if (!hostParams) return;
            const lagerplatzInhalt = hostParams.lagerplatz();
            const bewe = hostParams.bewe();
            const artikel = lagerplatzInhalt.inhalt.find(
              (o) => o.artikel.id === bewe?.artikelMengeOffen?.artikel?.id
            );

            if (!lagerplatzInhalt || !bewe || !artikel) {
              await this.store.dispatch(
                SOFTLINE_FEATURE_MESSAGE_BAR,
                MessageBarStore.actions.error,
                '#LAGERKORREKTUR_ARTIKEL.MESSAGES.ERROR.KOMMISSIONIERUNG_KEIN_ARTIKEL'
              );
              return;
            }

            hostParams.disabled$.next(true);

            this.store.commit(
              SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL,
              LagerkorrekturArtikelStore.mutations.setLagerplatz,
              lagerplatzInhalt
            );
            this.store.commit(
              SOFTLINE_FEATURE_LAGERKORREKTUR_ARTIKEL,
              LagerkorrekturArtikelStore.mutations.setArtikel,
              artikel
            );

            let result = await this.store.dispatch(
              SOFTLINE_FEATURE_MODAL,
              ModalStore.actions.open(),
              {
                component: MengenAuswahlDialog,
                dismiss: true,
              }
            );

            if (result === 'DISMISSED') {
              hostParams.disabled$.next(false);
              return;
            }

            result = await this.store.dispatch(
              SOFTLINE_FEATURE_MODAL,
              ModalStore.actions.open(),
              {
                component: UmbuchungsartikelAuswahlDialog,
                dismiss: true,
              }
            );

            if (result === 'DISMISSED') {
              hostParams.disabled$.next(false);
              return;
            }

            await hostParams.loadLagerplatzVorschlag(bewe);
            hostParams.disabled$.next(false);
          },
        },
      ];
    });
  }
}
